import { Dispatch } from 'redux';
import { AdminApi, AuthenticationApi } from '../../../api/api.apiclient';
import { UserModel } from '../../../api/authentication/authentication.types';
import {
  LOGIN_FAILED,
  LOGIN_SUCCESSFUL,
  LoginAction,
  LOGOUT_SUCCESSFUL,
  LogoutAction,
  STORE_ACTIVE_SUPPLIER,
  STORE_USER_CHANGES,
  StoreActiveSupplierAction,
  StoreUserChangesAction,
  TOKEN_INVALID,
  TOKEN_VALID,
  ValidateTokenAction
} from '../types/authentication.types';
import {
  LOCALSTORAGE_ACTIVE_SUPPLIER,
  LOCALSTORAGE_SUPPLIERS,
  LOCALSTORAGE_TOKEN_FIELD,
  LOCALSTORAGE_USER_FIELD
} from '../../../types/app.index';
import { SupplierModel } from '../../../api/admin/admin.types';

export const performLogin = (username: string, password: string) => async (dispatch: Dispatch<LoginAction>) => {
  try {
    const { user, token, suppliers }: {
      user: UserModel;
      token: string;
      suppliers: SupplierModel[]
    } = await AuthenticationApi.authentication.login({ username, password });
    localStorage.setItem(LOCALSTORAGE_TOKEN_FIELD, token);
    localStorage.setItem(LOCALSTORAGE_USER_FIELD, JSON.stringify(user));
    localStorage.setItem(LOCALSTORAGE_SUPPLIERS, JSON.stringify(suppliers));
    localStorage.setItem(LOCALSTORAGE_ACTIVE_SUPPLIER, JSON.stringify(suppliers[ 0 ]));
    dispatch({
      type: LOGIN_SUCCESSFUL,
      payload: {
        user,
        token,
        suppliers,
        activeSupplier: suppliers[ 0 ]
      }
    });
  } catch (e) {
    dispatch({
      type: LOGIN_FAILED
    });
  }
};

export const performLogout = () => async (dispatch: Dispatch<LogoutAction>) => {
  await AuthenticationApi.authentication.logout();
  localStorage.clear();
  dispatch({
    type: LOGOUT_SUCCESSFUL
  });
  window.location.replace('/login');
};

export const validateToken = () => async (dispatch: Dispatch<ValidateTokenAction>) => {
  try {
    await AuthenticationApi.authentication.validateToken();
    dispatch({
      type: TOKEN_VALID
    });
  } catch (e) {
    dispatch({
      type: TOKEN_INVALID
    });
  }

};

export const storeActiveSupplier = (supplier: SupplierModel) => async (dispatch: Dispatch<StoreActiveSupplierAction>) => {
  dispatch({
    type: STORE_ACTIVE_SUPPLIER,
    payload: {
      activeSupplier: supplier
    }
  });
};

export const storeUserChanges = (user: UserModel) => async (dispatch: Dispatch<StoreUserChangesAction>) => {
  console.log(user);
  localStorage.setItem(LOCALSTORAGE_USER_FIELD, JSON.stringify(user));
  dispatch({
    type: STORE_USER_CHANGES,
    payload: {
      user: user
    }
  });
};

export const getSupplier = () => async (dispatch: Dispatch<any>) => {

  const response = await AdminApi.suppliers.getSupplier();
  localStorage.setItem(LOCALSTORAGE_ACTIVE_SUPPLIER, JSON.stringify(response.data));
  dispatch({
    type: STORE_ACTIVE_SUPPLIER,
    payload: { activeSupplier: response.data }
  });

  return Promise.resolve();
};


